export default "__VITE_ASSET__J1YXKlMh__"